import HeroSection from "../../Components/HeroSection";
import HowItWorksSection from "../../Components/HowItWorksSection";
import DownloadPDFStrip from "../../Components/DownloadPDFStrip";
import BookTrialClassForm from "../../Components/BookTrialClassForm";
import WhatMakesShyftBootCampUniqueSection from "../../Components/WhatMakesShyftBootCampUniqueSection";
import CallbackSection from "../../Components/CallbackSection";
import Testimonials from "@/components/Organisms/TestimonialsV2";
import RealWorldTransformation from "../../Components/RealWorldTransformation";
import AppBannerSection from "../../Components/AppBannerSection";
import BootcampListing from "../../Components/BootcampListing";
import AllPackagesSection from "../../Components/AllPackagesSection";
import ReadyToBuildSection from "../../Components/ReadyToBuildSection";
import FaqSection from "@/components/Molecules/FaqSection";
import FloatingBanner from "../../Components/FloatingBanner";
import BookSlotModal from "../../Components/BookSlotModal";
import CustomIntercomButton from "../../Components/CustomIntercomButton";

import CertifiedInstructors from "../../Components/Shared/CertifiedInstructors";

import { classNameGenerator } from "@/utils";

import { useAppSelector } from "@/hooks";

import styles from "./YogaForHealthConditionPage.module.scss";
import SymptomsAndConditionsSection from "../../Components/SymptomsAndConditionsSection";
import InstructorDetails from "../../Components/InstructorDetails";
import BenefitsForm from "../../Components/BenefitsForm";

interface YogaForHealthConditionPageProps { }

const YogaForHealthConditionPage: React.FC<
  YogaForHealthConditionPageProps
> = () => {
  const cls = classNameGenerator(styles);

  const { data } = useAppSelector((state) => state.bootCamp);

  const { titleMobile = "" } = data?.SymptomsAndConditionsSection || {}

  const { testimonies } = data?.testimonials || {};
  const faqs = data?.faqs || {};

  return (
    <div className={cls("yogaForHealthConditionPage")}>
      <HeroSection />
      <BenefitsForm>
        <BookTrialClassForm />
      </BenefitsForm>
      <HowItWorksSection>
        <BookTrialClassForm />
      </HowItWorksSection>
      <InstructorDetails />
      {data?.SymptomsAndConditionsSection && <SymptomsAndConditionsSection
        titleMobile={titleMobile}
      />}
      <div className={cls("downloadPDFWrapper")}>
        <DownloadPDFStrip />
      </div>
      <WhatMakesShyftBootCampUniqueSection />
      <Testimonials testimonies={testimonies} />
      <CallbackSection />
      <RealWorldTransformation />
      <AllPackagesSection />
      <AppBannerSection />
      <div className={cls("certifiedInstructors")}>
        <CertifiedInstructors />
      </div>
      <BootcampListing />
      <FaqSection {...faqs} />
      <ReadyToBuildSection />
      <FloatingBanner />
      <BookSlotModal title={data?.bookSlotForm?.title} upperHeading={data?.bookSlotForm?.upperHeading} />
      {/* <CustomIntercomButton /> */}
    </div>
  );
};

export default YogaForHealthConditionPage;
